import { useEffect, useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Heart } from 'lucide-react';

interface CountdownWidgetProps {
  weddingDate: Date;
}

interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

const CountdownWidget = ({ weddingDate }: CountdownWidgetProps) => {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = weddingDate.getTime() - new Date().getTime();
      
      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, [weddingDate]);

  const TimeBlock = ({ value, label }: { value: number; label: string }) => (
    <div className="text-center">
      <div className="bg-gradient-to-b from-background to-muted/50 rounded-xl p-4 md:p-6 border border-border shadow-soft min-w-[70px] md:min-w-[90px]">
        <span className="font-serif text-3xl md:text-5xl font-medium text-foreground">
          {value.toString().padStart(2, '0')}
        </span>
      </div>
      <span className="text-xs md:text-sm text-muted-foreground mt-2 block uppercase tracking-wider">
        {label}
      </span>
    </div>
  );

  return (
    <Card className="bg-gradient-to-br from-blush-light/30 via-card to-sage-light/20 border-primary/10 shadow-card overflow-hidden">
      <CardContent className="p-6 md:p-8">
        <div className="text-center mb-6">
          <div className="inline-flex items-center gap-2 mb-2">
            <Heart className="w-5 h-5 text-primary fill-primary/20" />
            <span className="text-sm uppercase tracking-widest text-muted-foreground">
              Cuenta Regresiva
            </span>
            <Heart className="w-5 h-5 text-primary fill-primary/20" />
          </div>
          <h3 className="font-serif text-xl md:text-2xl text-foreground">
            Tu Gran Día se Acerca
          </h3>
        </div>
        
        <div className="flex justify-center gap-3 md:gap-6">
          <TimeBlock value={timeLeft.days} label="Días" />
          <TimeBlock value={timeLeft.hours} label="Horas" />
          <TimeBlock value={timeLeft.minutes} label="Min" />
          <TimeBlock value={timeLeft.seconds} label="Seg" />
        </div>
      </CardContent>
    </Card>
  );
};

export default CountdownWidget;
